<template>
  <div>
    <div class="text-center p-16" v-if="isLoadingVenues">
      <p class="opacity-60">Getting started</p>
      <span class="flex h-12 w-12 mx-auto mt-5">
        <span
          class="
            animate-ping
            absolute
            inline-flex
            h-12
            w-12
            rounded-full
            bg-primary
            opacity-75
          "
        ></span>
        <span
          class="relative inline-flex rounded-full h-12 w-12 bg-primary"
        ></span>
      </span>
    </div>
    <div v-if="!isLoadingVenues">
      <div class="grid grid-cols-1 tablet:grid-cols-3 xxl:grid-cols-4">
        <div v-if="isLoadingBookings">
          <p class="opacity-60">Finding bookings</p>
          <span class="flex h-12 w-12 mx-auto mt-5">
            <span
              class="
                animate-ping
                absolute
                inline-flex
                h-12
                w-12
                rounded-full
                bg-primary
                opacity-75
              "
            ></span>
            <span
              class="relative inline-flex rounded-full h-12 w-12 bg-primary"
            ></span>
          </span>
        </div>
        <div v-if="!selectedVenue" class="tablet:col-span-2 xxl:col-span-3">
          <hr
            class="mb-2 mt-4 mr-8"
            style="
              border-top: 2px dotted #e3e3e3;
              border-bottom: none;
              border-left: none;
              border-right: none;
            "
          />
          <div class="flex my-4">
            <p class="text-grey mr-3 my-auto">Location:</p>
            <vs-select v-model="location">
              <vs-select-item
                :placeholder="'Placeholder'"
                :key="index"
                :value="item"
                :text="item.name"
                v-for="(item, index) in locations"
              />
            </vs-select>
            <vs-button
              class="ml-2"
              v-if="location"
              size="small"
              @click="location = null"
              >x</vs-button
            >

            <p class="text-grey mr-3 my-auto ml-8">Country:</p>
            <vs-select v-model="country">
              <vs-select-item
                :placeholder="'Placeholder'"
                :key="index"
                :value="item"
                :text="item.name"
                v-for="(item, index) in countries"
              />
            </vs-select>
            <vs-button
              class="ml-2"
              v-if="country"
              size="small"
              @click="country = null"
              >x</vs-button
            >
          </div>

          <hr
            class="mb-2 mt-4 mr-8"
            style="
              border-top: 2px dotted #e3e3e3;
              border-bottom: none;
              border-left: none;
              border-right: none;
            "
          />
        <div
          style="
            background-color: rgb(255 212 134) !important;
            color: rgb(139 93 10) !important;
          "
          v-for="venueNote in venueNotes"
          :key="venueNote.id"
          class="
            bg-warning bg-yellow-100
            opacity-80
            p-4
            rounded
            
            mr-8
            text-yellow-900 text-sm
            shadow-lg
          "
        >
          <p>
            <span class="font-bold">
              {{ activeVenue.name + " - "+ formatVenueNoteDate(venueNote) }}
            </span>
            - {{ getUserName(venueNote) }}
          </p>
          <p><pre>{{ venueNote.message }}</pre></p>
        </div>

          <div
            v-if="!isLoadingBookings"
            class="pl-12 p-6"
            style="margin-left: -3rem"
          >
            <div
              v-if="
                sortedAndFilteredVenues && sortedAndFilteredVenues.length == 0
              "
            >
              <p class="text-grey">No venues found</p>
            </div>
            <div
              v-for="(venue, index) in sortedAndFilteredVenues"
              :key="index"
              class="
                bg-white
                shadow-lg
                mb-4
                rounded-lg
                flex
                justify-between
                cursor-pointer
              "
              @click="selectVenue(venue)"
            >
              <div class="p-6 px-8">
                <h4>{{ venue.name }}</h4>
                <p class="text-grey">
                   {{
                    getBookingCount(venue.id)
                   }}
                  guests 
                </p>
              </div>
              <div
                class="flex rounded-r-lg relative"
                style="background-color: #f0f2f4 !important; width: 8rem;"
              >
                <div
                  class="absolute"
                  style="height: 100%"
                  :style="{
                    width: tableOccupancyRate(venue) + '%',
                    background:
                      venue.occupancyRate < 95
                        ? '#00ff0047'
                        : venue.occupancyRate >= 95
                        ? '#ffff0047'
                        : '#ff000047',
                  }"
                ></div>
                <p class="m-auto z-10">
                  {{ getFixedOccupancyRate(venue.occupancyRate)}} %
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!isLoadingBookings && selectedVenue"
          class="pl-12 p-6 tablet:col-span-2 xxl:col-span-3"
          style="margin-left: -3rem"
        >
          <vs-button
            @click="handleBackToVenueOverviewClick"
            size="small"
            icon-pack="feather"
            icon="icon-arrow-left"
            class="mb-6"
            >Back to venue overview</vs-button
          >
          <guest-relations-venue-booking-overview
            :date="pDate"
            :venueNotes="venueNotes"
            :venueDetails="selectedVenue"
            v-if="
              hasPermissionForActiveVenue(
                'vp.crm.bookingoverview.viewvenueoverview'
              )
            "
            @trigger-booking-percentage-update="handleTriggerBookingPercentageUpdate"
          ></guest-relations-venue-booking-overview>
        </div>
        <div class="p-4">
          <DatePicker
            locale="en"
            :first-day-of-week="1"
            :attributes="calendarAttributes"
            is-expanded
            v-model="pDate"
            @dayclick="handleDayClick($event)"
            @update:from-page="handleCalendarPageChange($event)"
            @update:to-page="handleCalendarPageChange($event)"
          ></DatePicker>
          <div class="mt-4">
            <h4>Activation Plan Events</h4>
            <span v-if="!events || events.length === 0">No events</span>
            <a
              v-for="event in events"
              :key="'activations-plan-event' + event.activationPlanEventId"
              @click="handleActivationEventCardClick(event)"
            >
              <vs-card class="activation-event-card">
                <h5>{{ event.title }}</h5>
                <span>{{ getVenueName(event.venueId) }}</span>
              </vs-card>
            </a>
          </div>
        </div>
      </div>
    </div>

    <popup-activation-event-details ref="popupActivationEventDetails" />
  </div>
</template>

<script>
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";
import { ACTIONS as BOOKING_ACTIONS } from "@/store/modules/marcom/marcom-booking";

import { mapGetters } from "vuex";
import Vue from "vue";
//import flatPickr from "vue-flatpickr-component";
import moment from "moment";
import { DatePicker } from "v-calendar";
import GuestRelationsVenueBookingOverview from "../components/GuestRelationsVenueBookingOverview.vue";
import PopupActivationEventDetails from "../../popups/PopupActivationEventDetails.vue";
import { BookingsByDateQuery } from "@/store/modules/marcom/data-model/bookings/queries-and-commands/bookings-by-date-query.js";
import { GetVenueNotesQuery } from "@/store/modules/marcom/data-model/venue-notes/queries-and-commands/get-venue-notes-query";

export default {
  components: {
    //flatPickr,
    DatePicker,
    GuestRelationsVenueBookingOverview,
    PopupActivationEventDetails,
  },
  data() {
    const pDate = new Date();
    return {
      isLoadingVenues: true,
      isLoadingBookings: false,
      venues: null,
      sortedAndFilteredVenues: null,
      pDate,
      selectedVenue: null,
      pLocation: null,
      country: null,
      countries: [
        {
          name: "Denmark",
          id: "dk",
        },
      ],
      sortMode: "occupancy",
      bookingPercentageByDate: [],
      bookingPercentageByVenue: [],
    };
  },
  async mounted() {
    await this.$store.dispatch("marcom/" + VENUE_ACTIONS.GetLocations);
    this.venues = await this.$store.dispatch(
      "marcom/" + VENUE_ACTIONS.GetVenues
    );
    await this.$store.dispatch("marcom/" + VENUE_ACTIONS.FindActiveVenue, {
      venuePortalId: this.activeVenue.venueId,
    });
    this.isLoadingVenues = false;
    await this.searchBookings();

    await this.searchActivationPlanEvents();

    if (this.selectedVenue) {
      const mDate = moment(this.pDate);
      await this.getBookingPercentages(mDate.year(), mDate.month() + 1);
    } else {
      await this.getBookingPercentagesByDate();
    }
    await this.getVenueNotes();
  },
  computed: {
    ...mapGetters({
      locations: "marcom/locations",
      isLoadingLocations: "marcom/isLoadingLocations",
      enhancedBookings: "marcomBooking/enhancedBookings",
      activeVenue: "venues/activeVenue",
      user: "users/user",
      activeVenueDetails: "marcom/activeVenue",
      event: "activationPlan/event",
      events: "activationPlan/events",
    }),

    location: {
      get() {
        return this.pLocation;
      },
      set(value) {
        this.pLocation = value;
        this.sortAndFilterVenues();
      },
    },
    calendarAttributes() {
      return [
        {
          key: "today",
          highlight: "gray",
          dates: new Date(),
        },
        {
          key: "sold-out",
          highlight: "red",
          popover: {
            label: "Sold out",
          },
          dates: this.bookingPercentageByVenue
            .filter((bp) => bp.bookingPercent >= 100)
            .map((bp) => new Date(bp.date)),
        },
      ];
    },
    venueNotes() {
      var notes = this.$store.state.marcom.venueNotes;
      var closedBookingNotes = notes.filter((n) => {
        return n.message.startsWith("Closed:");
      });
      return closedBookingNotes;
    },
  },
  methods: {
    async dateSelected() {
      await this.searchBookings();
      await this.searchActivationPlanEvents();
      await this.getVenueNotes();
      if (!this.selectedVenue) await this.getBookingPercentagesByDate();
    },
    async searchBookings() {
      if (this.selectedVenue || !this.pDate || !this.activeVenueDetails) return;

      let startTimeOfDay = this.activeVenueDetails.startTimeOfDay.split(":");

      let nightStart = moment(this.pDate);
      nightStart = moment
        .utc([nightStart.year(), nightStart.month(), nightStart.date()])
        .add(startTimeOfDay[0], "hours")
        .add(startTimeOfDay[1], "minuttes");
      let nightEnd = moment(nightStart).add(1, "days");
      //PROBLEM: startTimeOfDay can be different pr venue!!!
      var bookingQuery = new BookingsByDateQuery(
        nightStart.toJSON(),
        nightEnd.toJSON()
      );

      await this.$store.dispatch(
        "marcomBooking/" + BOOKING_ACTIONS.SearchBookings,
        bookingQuery
      );
    },
    async searchActivationPlanEvents() {
      await this.$store.dispatch("activationPlan/getEventsByDate", {
        date: moment(this.pDate).format("YYYY-MM-DD"),
        venueId: this.selectedVenue
          ? this.selectedVenue.venuePortalId
          : undefined,
      });
    },
    tableOccupancyRate(venue) {

      const rate = this.bookingPercentageByDate.find(
        (bp) => bp.venueDetailsId.id === venue.venueDetailsId.id
      );
      return rate ? rate.bookingPercent == "Infinity" ? 0 : rate.bookingPercent  : 0;
    },

    sortAndFilterVenues() {
      this.sortedAndFilteredVenues = [...this.venues];

      switch (this.sortMode) {
        case "occupancy": {
          this.sortedAndFilteredVenues = this.sortedAndFilteredVenues.sort(
            (a, b) => b.occupancyRate - a.occupancyRate
          );
          break;
        }
        default:
          break;
      }

      if (this.location)
        this.sortedAndFilteredVenues = this.sortedAndFilteredVenues.filter(
          (v) => v.locationId.id == this.location.id
        );
    },

    async selectVenue(venue) {
      this.selectedVenue = venue;
      await this.searchActivationPlanEvents();

      const mDate = moment(this.pDate);
      await this.getBookingPercentages(mDate.year(), mDate.month() + 1);
      this.bookingPercentageByDate = [];
    },
    handleBackToVenueOverviewClick() {
      setTimeout(async () => {
        this.selectedVenue = null;
        await this.searchActivationPlanEvents();
        await this.getBookingPercentagesByDate();
        await this.searchBookings();
        this.bookingPercentageByVenue = [];
      }, 100);
    },
    getVenueName(venuePortalId) {
      if (!venuePortalId) return "No particalur venue";
      const venue = this.venues.find((v) => v.venuePortalId === venuePortalId);
      if (venue) return venue.name;
      return "Unknown venue";
    },
    handleActivationEventCardClick(event) {
      this.$refs.popupActivationEventDetails.show(
        this.getVenueName(event.venueId),
        event
      );
    },
    async handleTriggerBookingPercentageUpdate() {
      const mDate = moment(this.pDate);
      await this.getBookingPercentages(mDate.year(), mDate.month() + 1);
    },
    async getBookingPercentages(year, month) {
      this.bookingPercentageByVenue = await this.$store.dispatch(
        "marcom/" + VENUE_ACTIONS.GetBookingPercentageMonth,
        {
          venueDetailsId: this.selectedVenue.venueDetailsId,
          year: year,
          month: month,
        }
      );
    },
    async getBookingPercentagesByDate() {
      const mDate = moment(this.pDate);

      this.bookingPercentageByDate = await this.$store.dispatch(
        "marcom/" + VENUE_ACTIONS.GetBookingPercentageByDateAndVenueDetailIds,
        {
          date: mDate.format("YYYY-MM-DD"),
          venueDetailsIds: this.venues.map((v) => v.venueDetailsId),
        }
      );

      for (const venue of this.venues) {
        Vue.set(venue, "occupancyRate", this.tableOccupancyRate(venue));
      }
      this.sortAndFilterVenues();
    },
    handleDayClick(eventObj) {
      this.dateSelected();
    },
    async handleCalendarPageChange(eventObj) {
      if (this.selectedVenue)
        await this.getBookingPercentages(eventObj.year, eventObj.month);
    },

    getBookingCount(venueId) {
      const bookingsForVenue = this.enhancedBookings.filter(
        (enhancedBooking) => {
          return enhancedBooking.booking.venueDetailsId.id == venueId;
        }
      );
      return bookingsForVenue.length > 0
        ? bookingsForVenue.reduce(
            (acc, cur) => (acc += cur.booking.guestCount),
            0
          )
        : 0;
    },

    async getVenueNotes() {
      if (!this.activeVenueDetails) return;
      let query = new GetVenueNotesQuery(
        this.pDate,
        this.activeVenueDetails.venueDetailsId
      );

      return this.$store.dispatch(
        "marcom/" + VENUE_ACTIONS.GetVenueNotes,
        query
      );
    },
    formatVenueNoteDate(venueNote) {
      let noteMoment = moment.utc(venueNote.date);
      return noteMoment.format("DD-MM-YYYY");
    },
    getUserName(venueNote) {
      const theUser = this.user(venueNote.createdBy.id);
      return theUser
        ? `${theUser.firstName} ${theUser.lastName}`
        : "Unknown user";
    },
    getFixedOccupancyRate(occupancy){
      if (occupancy == "Infinity"){
        return 0
      } else {
        return occupancy.toFixed(0)
      }
    }
  },
};
</script>

<style scoped>
.layout-grid {
  display: grid;
  grid-template-columns: 6fr 2fr;
}

.vc-container {
  background: transparent;
  border: none;
}

.activation-event-card {
  cursor: pointer;
}
</style>
